"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Workflow Automation
 * Worklow Automation API We  support the following components<ul> <li><b>Action (or Task)</b> - Predefined units of work that the system can perform. An action could be something like send an email or assign the shipment to this carrier. An action<ul> <li>Will have a name</li> <li>May specify inputs it takes</li> <li>May specify outputs it produces</li> <li>Could throw an Exception</li></ul> <li><b>Junction</b> - Specifies how the different steps are connected to each other (converging, diverging)</li> <li><b>Start</b> - There must be one at least one place to start</li> <li><b>End</b> - Marks the end of a process workflow </li> <li><b>Data objects</b> - these objects will be defined and maintained by the development team. These objects could be things like shipments, companies, users, tenders etc.</li> <li><b>Signals</b> - Workflow steps can listen for an incoming signal for things like triggering the next step, interrupting execution or triggering other flows. </li></ul>
 *
 * The version of the OpenAPI document: 0.1.4
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(require("./api"), exports);
__exportStar(require("./configuration"), exports);
